import { MenteeWallView } from "@/components/wall/wall-panel";
import type { MentorshipDetails } from "@/lib/api/mentorships";
import { getPreferredName } from "@/lib/redacted-display";

export function TeenWallTab({ mentorship }: { mentorship: MentorshipDetails }) {
  const menteeName = getPreferredName(mentorship.mentee);

  return (
    <div className="h-[60vh] overflow-hidden rounded-xl border">
      <MenteeWallView mentorshipId={mentorship.id} menteeName={menteeName} />
    </div>
  );
}
